import RelevesAvailableLine from "./RelevesAvailableLine";
import { trpc } from "../../main/components/ProviderContainer.tsx";

interface SecuriteSocialeImportsAvailableProps {
  years: number[];
}

const SecuriteSocialeImportsAvailable = (
  props: SecuriteSocialeImportsAvailableProps,
) => {
  const { isError, isLoading, data } =
    trpc.banque.getSecuriteSocialeImportsMonthsAvailable.useQuery({
      yearStart: props.years[0],
      yearEndIncluding: props.years[props.years.length - 1],
    });

  if (!isError && !isLoading && data) {
    return (
      <div>
        <div style={{ marginTop: "8px", marginBottom: "4px", fontWeight: 700 }}>
          Imports Securite sociale disponibles
        </div>
        {Object.entries(data).map(([year, bools]) => (
          <RelevesAvailableLine
            monthesAvailable={bools}
            year={year}
            key={`${year}securiteSocialeImportsAvailableLineKey`}
          />
        ))}
      </div>
    );
  }

  return <div>Loading...</div>;
};

export default SecuriteSocialeImportsAvailable;
